import sectionDownload from './components/section/download/lang.fr';

export default {
  section: {
    download: sectionDownload,
  },
};
